import type { ReactNode } from "react";

export function SettingsRow({ title, detail, control }: { title: string; detail?: string; control?: ReactNode }) {
  return (
    <div className="settings-row">
      <div>
        <strong>{title}</strong>
        {detail ? <span>{detail}</span> : null}
      </div>
      {control ? <div className="settings-row__control">{control}</div> : null}
    </div>
  );
}
